import React from "react";
import BlogTwentyEight from "../component/BlogTwentyEight";

function BlogTwentyEightContainer() {
  return <BlogTwentyEight />;
}
export default BlogTwentyEightContainer;
